// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Sider_navbar__1349k"};